import { Flex } from "antd";
import { ReactElement, ReactNode } from "react";
import Skeleton from "../Skeleton/Skeleton";
import styles from "./FormItemContainer.module.scss";

export default function FormItemContainer({
  title,
  extra,
  type = "normal",
  children,
  isLoading = false,
  isRequired = false,
  isOptional = false,
  isIncomplete = false,
  right,
}: {
  title?: string | ReactElement;
  extra?: string | ReactElement;
  type?: "normal" | "main";
  children?: ReactNode;
  isLoading?: boolean;
  isRequired?: boolean;
  isOptional?: boolean;
  isIncomplete?: boolean;
  right?: ReactNode;
}) {
  return (
    <div
      className={`${styles.FormItemContainer} ${styles[type]} ${
        isIncomplete ? styles.incomplete : ""
      }`}
    >
      {title && (
        <span className={styles.header}>
          {isRequired && <span className={styles.required}>*</span>}
          {title}
          {isOptional && <span className={styles.optional}>(optional)</span>}
        </span>
      )}
      {extra && <div className={styles.extra}>{extra}</div>}
      <Flex gap={8}>
        <div className={styles.children}>
          {isLoading ? <Skeleton style={{ width: "100%", height: 32 }} /> : children}
        </div>
        {right}
      </Flex>
    </div>
  );
}
